import { useState } from "react";
import axios from "axios";
import API_URL from "../config/config";
import "../css/changePassword.css";

function ChangePassword() {
  const userId = localStorage.getItem("user_id");

  const [form, setForm] = useState({
    currentPassword: "",
    newPassword: "",
    confirmPassword: ""
  });

  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (form.newPassword !== form.confirmPassword) {
      alert("New passwords do not match.");
      return;
    }

    try {
      const res = await axios.put(`${API_URL}/change-password`, {
        userId,
        currentPassword: form.currentPassword,
        newPassword: form.newPassword
      });

      alert(res.data.message);

      setForm({
        currentPassword: "",
        newPassword: "",
        confirmPassword: ""
      });

    } catch (err) {
      alert(err.response?.data?.message || "Something went wrong");
    }
  };

  return (
    <div className="change-password-page">
      <div className="change-password-card">

        <h2>Change Password</h2>

        <form onSubmit={handleSubmit}>

          <input
            type="password"
            name="currentPassword"
            placeholder="Current Password"
            value={form.currentPassword}
            onChange={handleChange}
            required
          />

          <input
            type="password"
            name="newPassword"
            placeholder="New Password"
            value={form.newPassword}
            onChange={handleChange}
            required
          />

          <input
            type="password"
            name="confirmPassword"
            placeholder="Confirm New Password"
            value={form.confirmPassword}
            onChange={handleChange}
            required
          />

          <button type="submit">
            Change Password
          </button>

        </form>

      </div>
    </div>
  );
}

export default ChangePassword;